import { useState, useEffect } from 'react';
import { supabase } from '../../supabase';

function SocialChecklist({ setPaginaAtiva, setClienteSocialAtivo }) {
  const [clientes, setClientes] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [checklist, setChecklist] = useState({});
  const [carregando, setCarregando] = useState(true);
  const [mesAtual, setMesAtual] = useState(new Date());

  useEffect(() => {
    carregarTudo();
  }, [mesAtual]);

  const getMesRef = () => {
    return `${mesAtual.getFullYear()}-${String(mesAtual.getMonth() + 1).padStart(2, '0')}-01`;
  };

const carregarTudo = async () => {
  const mesRef = getMesRef();
  const [{ data: clts }, { data: etps }, { data: checks }] = await Promise.all([
    supabase.from('clientes').select('*, social_config_clientes(*)').eq('ativo', true).or('modulo_social.eq.true,servico.eq.captacao').order('nome'),    supabase.from('social_etapas').select('*').eq('ativo', true).order('ordem'),
    supabase.from('social_checklist').select('*').eq('mes_ref', mesRef),
  ]);
  setClientes(clts || []);
  setEtapas(etps || []);
  const map = {};
  (checks || []).forEach(c => {
    if (!map[c.cliente_id]) map[c.cliente_id] = {};
    map[c.cliente_id][c.etapa_id] = c;
  });
  setChecklist(map);
  setCarregando(false);
};

const getEtapasCliente = (cliente) => {
  return etapas.filter(e => e.servico === 'todos' || e.servico === cliente.servico);
};

  const toggleCheck = async (clienteId, etapaId) => {
    const mesRef = getMesRef();
    const existente = checklist[clienteId]?.[etapaId];
    if (existente) {
      await supabase.from('social_checklist').update({
        concluido: !existente.concluido,
        concluido_em: !existente.concluido ? new Date().toISOString() : null,
      }).eq('id', existente.id);
    } else {
      await supabase.from('social_checklist').insert({
        cliente_id: clienteId,
        etapa_id: etapaId,
        mes_ref: mesRef,
        concluido: true,
        concluido_em: new Date().toISOString(),
      });
    }
    carregarTudo();
  };

  const getProgresso = (clienteId) => {
    const cliente = clientes.find(c => c.id === clienteId);
    const etapasCliente = getEtapasCliente(cliente);
    const checks = checklist[clienteId] || {};
    const concluidos = etapasCliente.filter(e => checks[e.id]?.concluido).length;
    return { concluidos, total: etapasCliente.length };
  };

  const mudarMes = (dir) => {
    const novo = new Date(mesAtual);
    novo.setMonth(mesAtual.getMonth() + dir);
    setMesAtual(novo);
  };

  const getMesLabel = () => {
    const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
    return `${meses[mesAtual.getMonth()]} ${mesAtual.getFullYear()}`;
  };

  const totalConcluidos = clientes.filter(c => {
    const { concluidos, total } = getProgresso(c.id);
    return total > 0 && concluidos === total;
  }).length;

  const totalAndamento = clientes.filter(c => {
    const { concluidos, total } = getProgresso(c.id);
    return concluidos > 0 && concluidos < total;
  }).length;

  const totalNaoIniciados = clientes.filter(c => {
    const { concluidos } = getProgresso(c.id);
    return concluidos === 0;
  }).length;

  if (carregando) return <div className="flex items-center justify-center h-64"><p style={{ color: '#555' }}>Carregando...</p></div>;

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white">Social Media</h1>
        <div className="flex items-center gap-2">
          <button onClick={() => mudarMes(-1)}
            className="w-8 h-8 rounded-lg flex items-center justify-center transition-all"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>
            ‹
          </button>
          <span className="text-sm font-medium text-white px-2">{getMesLabel()}</span>
          <button onClick={() => mudarMes(1)}
            className="w-8 h-8 rounded-lg flex items-center justify-center transition-all"
            style={{ backgroundColor: '#111', border: '1px solid #1a1a1a', color: '#aaa' }}>
            ›
          </button>
        </div>
      </div>

      {/* Summary */}
      <div className="grid grid-cols-4 gap-3 mb-6">
        {[
          { label: 'Clientes ativos', val: clientes.length, cor: '#fff' },
          { label: 'Concluídos', val: totalConcluidos, cor: '#22c55e' },
          { label: 'Em andamento', val: totalAndamento, cor: '#f59e0b' },
          { label: 'Não iniciados', val: totalNaoIniciados, cor: '#ef4444' },
        ].map((s, i) => (
          <div key={i} className="rounded-xl p-4" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
            <p className="text-xs mb-2" style={{ color: '#555' }}>{s.label}</p>
            <p className="text-xl font-bold" style={{ color: s.cor }}>{s.val}</p>
          </div>
        ))}
      </div>

      {/* Tabela */}
      {clientes.length === 0 ? (
        <div className="rounded-xl p-8 text-center" style={{ backgroundColor: '#111', border: '1px solid #1a1a1a' }}>
          <p style={{ color: '#555' }}>Nenhum cliente com Social Media ativo.</p>
          <p className="text-xs mt-1" style={{ color: '#333' }}>Ative o módulo Social Media na página de Clientes.</p>
        </div>
      ) : (
        <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1a1a1a' }}>
          <table className="w-full" style={{ borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#111' }}>
                <th className="text-left px-4 py-3 text-xs font-medium" style={{ color: '#555', borderBottom: '1px solid #1a1a1a', minWidth: '160px' }}>
                  Cliente
                </th>
                {etapas.map(e => (
                  <th key={e.id} className="text-center px-3 py-3 text-xs font-medium" style={{ color: '#555', borderBottom: '1px solid #1a1a1a', minWidth: '100px' }}>
                    {e.nome}
                    {e.servico !== 'todos' && (
                      <span className="ml-1 text-xs" style={{ color: '#333' }}>360</span>
                    )}
                  </th>
                ))}
                <th className="text-left px-4 py-3 text-xs font-medium" style={{ color: '#555', borderBottom: '1px solid #1a1a1a', minWidth: '140px' }}>
                  Progresso
                </th>
              </tr>
            </thead>
            <tbody>
              {clientes.map((cliente, i) => {
                const { concluidos, total } = getProgresso(cliente.id);
                const pct = total > 0 ? (concluidos / total) * 100 : 0;
                const cor = pct === 100 ? '#22c55e' : pct > 0 ? '#f59e0b' : '#ef4444';
                return (
                  <tr key={cliente.id}
                    style={{ borderBottom: i < clientes.length - 1 ? '1px solid #1a1a1a' : 'none', backgroundColor: '#111' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#151515'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#111'}>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: cor }} />
                        <button
                          onClick={() => { setClienteSocialAtivo(cliente); setPaginaAtiva('social_cliente'); }}
                          className="text-sm font-medium text-white transition-colors text-left"
                          onMouseEnter={(e) => e.currentTarget.style.color = '#DCF127'}
                          onMouseLeave={(e) => e.currentTarget.style.color = '#fff'}>
                          {cliente.nome}
                        </button>
                        <span className="text-xs px-2 py-0.5 rounded-full font-medium flex-shrink-0"
                          style={{
                            backgroundColor: cliente.servico === '360' ? '#1e3a5f' : '#2e1a4a',
                            color: cliente.servico === '360' ? '#60a5fa' : '#c084fc',
                          }}>
                          {cliente.servico === '360' ? '360' : 'Cap'}
                        </span>
                      </div>
                    </td>
                   {etapas.map(etapa => {
                      const etapasCliente = getEtapasCliente(cliente);
                      const pertence = etapasCliente.some(e => e.id === etapa.id);
                      const check = checklist[cliente.id]?.[etapa.id];
                      const concluido = check?.concluido;
                      return (
                        <td key={etapa.id} className="px-3 py-3 text-center">
                          {pertence ? (
                            <button
                              onClick={() => toggleCheck(cliente.id, etapa.id)}
                              className="w-5 h-5 rounded flex items-center justify-center mx-auto transition-all"
                              style={{
                                backgroundColor: concluido ? '#DCF127' : 'transparent',
                                border: concluido ? 'none' : '1.5px solid #333',
                              }}>
                              {concluido && <span style={{ color: '#0a0a0a', fontSize: '11px', fontWeight: '700' }}>✓</span>}
                            </button>
                          ) : (
                            <span style={{ color: '#222', fontSize: '16px' }}>—</span>
                          )}
                        </td>
                      );
                    })}
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <div className="flex-1 rounded-full" style={{ backgroundColor: '#1a1a1a', height: '5px' }}>
                          <div className="rounded-full transition-all" style={{ width: `${pct}%`, height: '5px', backgroundColor: cor }} />
                        </div>
                        <span className="text-xs flex-shrink-0" style={{ color: '#555' }}>{concluidos}/{total}</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default SocialChecklist;